import {useEffect, useState } from "react";
import axios from "axios";
import {useSelector} from "react-redux";
import { BASE_URL } from "../utils/commonUrl";

const QuarterNames = ({childToParent}) => {
    const {user} = useSelector((state) => state["auth"]);
    const [quarterNames, setQuarterNames] = useState([]);

    useEffect(() => {
        GetSubmittedQuarterNames(user.registerID);
      }, []);

      const GetSubmittedQuarterNames = (id) => {        
        axios
          .post(BASE_URL + `/api/dashboard/GetSubmittedQuarterNames/${id}`)
          .then((response) => {
            setQuarterNames(response.data);
            
          })
          .catch(function (error) {
            console.log(error);
          });     
      };

    return (
        <select id="ddlQuarter" name="ddlQuarter" className="form-select form-select-sm" onChange={childToParent}
            aria-label=".form-select-sm example">
            <option value={-1}>{"-- Select Quarter --"}</option>
            {quarterNames.map((value, index) => <option key={index}
                                             value={value.quarterID}>{value.quarterName}</option>)}
        </select>
    )

}

export default QuarterNames